<template>
    <v-container>
        <!-- Selección de servicio -->
        <v-select v-model="servicioId" :items="servicios" item-text="nombre" item-value="id" label="Servicio" outlined
            @change="cargarEscenarios" />

        <!-- Parámetros operativos -->
        <v-row>
            <v-col cols="12" sm="4">
                <v-text-field v-model.number="tmg" label="TMG (segundos)" type="number" />
            </v-col>

            <v-col cols="12" sm="4">
                <v-text-field v-model.number="nivel" label="Nivel de servicio (%)" type="number" />
            </v-col>

            <v-col cols="12" sm="4">
                <v-text-field v-model.number="umbral" label="Umbral NS (segundos)" type="number" />
            </v-col>
        </v-row>

        <v-btn color="primary" @click="generarMatricesCruzadas">Calcular dotación</v-btn>

        <v-row class="mt-6">
            <v-col cols="6">
                <h3 class="text-center">Volumen (Transacciones)</h3>
                <vistaMatriz :matriz="matrizTransaccionesVolumen" :dias="diasMatriz" />
            </v-col>

            <v-col cols="6">
                <h3 class="text-center">Volumen (Horas)</h3>
                <vistaMatriz :matriz="matrizHorasVolumen" :dias="diasMatriz" />
            </v-col>
        </v-row>
        <v-row class="mt-4">
            <v-col cols="6">
                <h3 class="text-center">Agentes (Transacciones)</h3>
                <vistaMatriz :matriz="matrizTransaccionesAgentes" :dias="diasMatriz" />
            </v-col>

            <v-col cols="6">
                <h3 class="text-center">Agentes (Horas)</h3>
                <vistaMatriz :matriz="matrizHorasAgentes" :dias="diasMatriz" />
            </v-col>
        </v-row>
        <v-row class="mt-4">
            <v-col cols="6">
                <h3 class="text-center">Agentes con reductores (Transacciones)</h3>
                <vistaMatriz :matriz="matrizTransaccionesFinal" :dias="diasMatriz" />
            </v-col>

            <v-col cols="6">
                <h3 class="text-center">Agentes con reductores (Horas)</h3>
                <vistaMatriz :matriz="matrizHorasFinal" :dias="diasMatriz" />
            </v-col>
        </v-row>


    </v-container>
</template>
<script>
import vistaMatriz from '@/components/vista-matriz.vue';
export default {
    components: {
        vistaMatriz
    },
    data() {
        return {
            servicios: [],
            servicioId: null,

            tmg: 180,           // Tiempo medio de gestión en segundos
            nivel: 80,          // Nivel de servicio deseado (%)
            umbral: 20,         // Umbral NS en segundos

            escenarios: [],     // Intervalos desde la tabla
            resultados: [],     // Agentes requeridos calculados

            diasMatriz: [],
            ordenDias: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],

            // Cuatro matrices visuales
            matrizTransaccionesVolumen: {},
            matrizTransaccionesAgentes: {},
            matrizHorasVolumen: {},
            matrizHorasAgentes: {},
            matrizTransaccionesFinal: {},
            matrizHorasFinal: {},

        };
    },

    async mounted() {
        const res = await this.$axios.get('list-services');
        this.servicios = res.data;
        console.log(this.servicios);
    },

    methods: {
        async cargarEscenarios() {
            const res = await this.$axios.get(`escenarios/${this.servicioId}`);
            this.escenarios = res.data;
            this.resultados = [];
        },

        segundosEntre(inicio, fin) {
            const [hi, mi] = inicio.split(':').map(Number);
            const [hf, mf] = fin.split(':').map(Number);
            return (hf * 3600 + mf * 60) - (hi * 3600 + mi * 60);
        },

        aproximarErlang(T, G, N, S) {
            const carga = (T * G) / 3600;
            const factor = (100 - N) / 100;
            return carga + (factor * carga);
        },

        generarMatricesCruzadas() {
            const crearMatriz = (filtrados, transformFn) => {
                const agrupado = {};
                const diasDetectados = new Set();

                filtrados.forEach(e => {
                    const intervalo = `${e.intervalo_inicio} - ${e.intervalo_fin}`;
                    if (!agrupado[intervalo]) agrupado[intervalo] = {};

                    agrupado[intervalo][e.dia_semana] = transformFn(e);
                    diasDetectados.add(e.dia_semana);
                });

                const diasOrdenados = Array.from(diasDetectados).sort(
                    (a, b) => this.ordenDias.indexOf(a) - this.ordenDias.indexOf(b)
                );
                this.diasMatriz = diasOrdenados;

                // Asegura que cada fila tenga todos los días
                Object.values(agrupado).forEach(row => {
                    this.diasMatriz.forEach(dia => {
                        if (!row[dia]) row[dia] = null;
                    });
                });

                return agrupado;
            };

            const escTrans = this.escenarios.filter(e => e.tipo === 'transacciones');
            const escHoras = this.escenarios.filter(e => e.tipo === 'horas');

            this.matrizTransaccionesVolumen = crearMatriz(escTrans, e => e.volumen);
            this.matrizTransaccionesAgentes = crearMatriz(escTrans, e => {
                const volumenAjustado = e.volumen * 2;
                return Math.ceil(this.aproximarErlang(volumenAjustado, this.tmg, this.nivel, this.umbral));
            });


            this.matrizHorasVolumen = crearMatriz(escHoras, e => e.volumen);
            this.matrizHorasAgentes = crearMatriz(escHoras, e => {
                const segundos = this.segundosEntre(e.intervalo_inicio, e.intervalo_fin);
                return Math.ceil((e.volumen * this.tmg) / segundos);
            });

            const aplicarReductores = (agentes, utz, abs) => {
                const paso1 = Math.ceil(agentes / utz);
                const paso2 = Math.ceil(paso1 / (1 - abs));
                return paso2;
            };
            const servicio = this.servicios.find(s => s.id === this.servicioId);

            const utzDecimal = parseFloat(servicio.utilizacion) / 100;
            const absDecimal = parseFloat(servicio.ausentismo) / 100;

            this.matrizTransaccionesFinal = crearMatriz(escTrans, e => {
                const volumenAjustado = e.volumen * 2;
                const base = Math.ceil(this.aproximarErlang(volumenAjustado, this.tmg, this.nivel, this.umbral));
                return aplicarReductores(base, utzDecimal, absDecimal);
            });

            this.matrizHorasFinal = crearMatriz(escHoras, e => {
                const segundos = this.segundosEntre(e.intervalo_inicio, e.intervalo_fin);
                const base = Math.ceil((e.volumen * this.tmg) / segundos);
                return aplicarReductores(base, utzDecimal, absDecimal);
            });
        }
    }
};
</script>